






































































































import { Component, Watch } from 'vue-property-decorator';

import { HeaderList } from '@/components/Table/TableModel';
import {
  CustomSelectModel,
  CustomSelectGroup,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import { treatValue } from '@/utils/moneyTreatments';
import RowsTable from '@/components/Table/RowsTable.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import eventBus from '@/utils/eventBus';
import DateUtils from '@/utils/DateUtils';
import TransactionsService from '@/api/TransactionsService';
import BasePagination from '@/components/BasePagination/BasePagination.vue';
import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';
import TableCard from '@/componentsV2/molecules/TableCard/TableCard.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';

import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';
import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    FlexButton,
    RowsTable,
    SideModalHeader,
    CustomSelect,
    TextInput,
    ContentContainer,
    Table,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon,
    TableCard,
    Typography
  }
})
export default class Transactions extends BasePagination {
  pageName: string = 'Transactions';
  subTitle: string = 'Rewarded Coins';
  labelInputFilter: string = 'Search by customer name';
  service: TransactionsService = new TransactionsService();
  labelToFilter = 'extras';
  apiExtraKey = 'types';
  searchableFields = 'searchableFields=customer.name';

  constructor() {
    super();
  }

  created() {
    this.reloadList(true);
    this.initFilterModel();
  }

  @Watch('isLoading')
  showFullLoadingOnMobile() {
    if (this.isMobileDevice && this.isLoading) {
      this.$showLoaderWithLocker();

      return;
    }

    this.$hideLoader();
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get getFlags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  reloadList(clearList?: boolean, refreshCurrent?: boolean, query?: string) {
    if (clearList) {
      this.resetPagination();
      this.dataList.list = [];
      this.maxItems = false;
    }
    if (this.refreshing || this.maxItems) return;
    this.isLoading = true;
    this.refreshing = true;

    this.service
      .getRewardedCoins(
        this.sortField,
        this.sortOrder,
        this.pagination,
        this.query
      )
      .then(response => {
        const { data } = response;
        const { items, links } = data;
        if (refreshCurrent) {
          // refresh page and reinitilize pagination
          this.resetPagination();
          this.pagination = links.next;
          if (!links.next) this.maxItems = true;
          this.dataList.list = this.addRowsToList(items);
        } else {
          // refresh page and add items
          this.dataList.list = this.dataList.list.concat(
            this.addRowsToList(items)
          );
          if (!links.next) this.maxItems = true;
          this.pagination = links.next;
        }
      })
      .catch(() => {})
      .finally(() => {
        this.isLoading = false;
        this.refreshing = false;
      });
  }

  //basic functions to initi base page
  initFilterModel() {
    const actionGroup = new CustomSelectGroup(
      [
        new CustomSelectOption('business-gift', `Manually rewarded`),
        new CustomSelectOption('app-payment', `Purchase bonus via app`),
        new CustomSelectOption('physical-payment', `Loyalty rewarded`),
        new CustomSelectOption('first-coin', `First Coin`)
      ],
      'Filter by type'
    );

    this.filterModel = new CustomSelectModel(
      [actionGroup],
      `Filter by type`,
      false,
      true,
      true,
      false
    );
  }

  // TODO ADD TYPES
  addRowsToList(rows: any): any[] {
    let rowsOrdered: any[] = [];
    rows.forEach((row: any) => {
      rowsOrdered.push({
        name: `${row.customer_name} ${row.customer_lastname}`,
        spent: `$${treatValue(row.totalSpent) || '0'}`,
        reward: treatValue(row.totalRewards) || '0',
        coins: treatValue(row.totalCoins) || '0',
        visits: treatValue(row.totalVisits) || '0',
        id: row.customer_id,
        last_seen: DateUtils.formatISODate(row.lastSeen),

        totalCoins: treatValue(row.transaction_bonusCoins),
        transactionId: row.transaction_id,
        date: DateUtils.formatISODate(row.transaction_createdAt),
        type: this.getRewardType(row.transaction_type)
      });
    });

    return rowsOrdered;
  }

  getRewardType(type: string) {
    let typeString: string = '';

    switch (type) {
      case 'business-gift':
        typeString = 'Manually rewarded';
        break;

      case 'app-payment':
        typeString = 'Purchase bonus via app';
        break;

      case 'physical-payment':
        typeString = 'Loyalty rewarded';
        break;

      case 'first-coin':
        typeString = 'First Coin';
        break;

      default:
        break;
    }

    return typeString;
  }

  detail(event: any) {
    const modalConfig = {
      isOpen: true,
      disabledBackdropClick: true,
      component: 'customerDetails',
      data: event
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  initHeader() {
    this.dataList.header.push(new HeaderList(`Customer name`, 'customer.name'));
    this.dataList.header.push(
      new HeaderList(`Total Coins rewarded`, 'transaction.bonusCoins')
    );
    this.dataList.header.push(new HeaderList(`Date`, 'transaction.createdAt'));
    this.dataList.header.push(new HeaderList(`Action`, 'transaction.type'));
  }
}
